<template>
  <CCard>
    <CCardHeader
      style="background: #1a3665; color: white"
      class="d-flex align-items-center font-weight-bold"
    >
      Master Level 
      <template v-if="role_status && role_status.status_create">
      <CButton
        color="success"
        class="btn-md ml-auto button-md-block px-3"
        @click="createData"
        >Tambah</CButton
      >
      </template>
      <template v-else>
        <CButton
        color="secondary"
        class="btn-md ml-auto button-md-block px-3"
        disabled
        >Tambah</CButton
      >
      </template>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            v-model="search"
            placeholder="Cari Data .."
          />
          <br />
        </CCol>
        <!-- <div class="col-lg-6 col-sm-12 col-md-5 d-flex align-items-center">          
        </div>-->
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable
            style="widht: 100% !important"
            :items="items"
            :fields="fields"
            hover
            sorter
          >
            <template #no="{ index }">
              <td class="py-2">
                {{ indexed == 0 ? index + 1 : index + indexed + 1 }}
              </td>
            </template>

            <template #namaTingkatan="{ item }">
              <td class="py-2 text-left">
                {{ item.namaTingkatan ? item.namaTingkatan : "-" }}
              </td>
            </template>

            <template #hargaLevel="{ item }">
              <td class="py-2 text-left">
                {{ item.hargaLevel ? 'Rp. '+formatPrice(item.hargaLevel) : "-" }}
              </td>
            </template>

            <template #namaLevel="{ item }">
              <td class="py-2 text-left">
                {{ item.namaLevel ? item.namaLevel : "-" }}
              </td>
            </template>

            <template #status="{ item }">
              <td class="py-2 text-center">
                <font-awesome-icon
                  icon="check"
                  class="text-success"
                  v-if="item.status == 1"
                />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{ item, index }">
              <td class="py-2 text-center">
                <template v-if="role_status && role_status.status_update">
                  <CButton
                    v-c-tooltip="'Ubah'"
                    color="info"
                    square
                    size="sm"
                    @click="updateData(item, index)"
                  >
                    <font-awesome-icon icon="edit" /> </CButton
                  >&nbsp;&nbsp;
                </template>
                <template v-else>
                  <CButton
                    v-c-tooltip="'Ubah'"
                    color="secondary"
                    square
                    size="sm"
                    disabled
                  >
                    <font-awesome-icon icon="edit" /> </CButton
                  >&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton
                  v-c-tooltip="'Hapus'"
                  color="danger"
                  square
                  size="sm"
                  @click="deleteData(item, index)"
                >
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
                <template v-else>
                <CButton
                  v-c-tooltip="'Hapus'"
                  color="secondary"
                  square
                  size="sm"
                  disabled
                >
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>

          <CPagination
            style="float: right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>

      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <CCol sm="12" style="display: none">
              <CInput
                class="font-weight-bold"
                label="Nama Tingkatan"
                v-model="formData.namaTingkatan"
                placeholder="Masukkan nama tingkatan"                
              />
            </CCol>
            <CCol sm="12 mb-3">
              <label for="level" class="font-weight-bold">Nama Level</label>
              <input
                type="text"
                class="form-control"
                :class="{
                  'is-invalid': $v.formData.namaLevel.$error,
                }"
                id="levelInput"
                placeholder="Masukkan nama level"
                v-model="formData.namaLevel"
                aria-required="true"
                @input="setNamaLevel($event.target.value)"
                @keyup.enter="postData"
              />
            </CCol>
            <CCol sm="12 mb-3">
              <label for="level" class="font-weight-bold">Harga Level</label>
              <input
                type="number"
                class="form-control"
                :class="{
                  'is-invalid': $v.formData.hargaLevel.$error,
                }"
                id="hargaInput"
                placeholder="Masukkan Harga"
                v-model="formData.hargaLevel"
                aria-required="true"
                @input="setHarga($event.target.value)"
                @keyup.enter="postData"
              />
            </CCol>

            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    value="1"
                    v-model="formData.status"
                    id="aktif"
                    checked
                  />
                  <label class="custom-control-label" for="aktif">Aktif</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    value="0"
                    id="tidak_aktif"
                    v-model="formData.status"
                  />
                  <label class="custom-control-label" for="tidak_aktif"
                    >Tidak Aktif</label
                  >
                </div>
              </div>
              <span v-if="$v.formData.status.$error" class="text-danger">
                *Mohon pilih status
              </span>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{ title }}</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success"
            >Simpan</CButton
          >
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
  </CCard>
</template>
<script>
import { required } from "vuelidate/lib/validators";

/**
 *
 * level service diimport agar bisa menggunakan fungsi consume API nya
 * lokasi nya ada di "../../services/datamaster/level.service";
 *
 */

import LevelService from "../../services/datamaster/level.service";
import { AlertUtils } from "../../mixins/AlertUtils";

const fields = [
  { key: "no", _style: "width: 8%" },

  // {
  //   key: "namaTingkatan",
  //   label: "Tingkatan",
  // },
  {
    key: "namaLevel",
    label: "Level",
    _style: "text-align: left; width: 40%",
  },
  {
    key: "hargaLevel",
    label: "Biaya Level",
    _style: "text-align: left; width: 40%",
  },
  { key: "status", _style: " text-align: center" },
  { key: "aksi", _style: "width:15%; text-align: center" },
];

export default {
  name: "Level",
  mixins: [AlertUtils],
  data() {
    return {
      items: [],
      title: "",
      actionPost: "",
      formData: {
        namaLevel: "",
        namaTingkatan: "",
        status: "",
        idLevelAnggota: "",
        hargaLevel: 0
      },
      pagination: {
        totalPages: 0,
      },
      currentPage: 0,
      details: [],
      fields,
      no: 1,
      search: "",
      pageSize: "",
      indexed: 0,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      role_status: null,
    };
  },

  validations: {
    formData: {
      namaLevel: { required },
      status: { required },
      hargaLevel: {required}
    },
  },

  watch: {
    search: function (val) {
      clearTimeout(this.timeout);
      var vm = this;
      this.timeout = setTimeout(function () {
        // enter this block of code after 1 second
        // handle stuff, call search API etc.
        vm.getData("0", vm.pageSize, vm.search);
      }, 1000);
    },
    currentPage: function (val) {
      // alert(val-1);
      var page = val - 1;
      this.indexed = page * 10;
      // alert(this.indexed);
      this.getData(val - 1, this.pageSize, this.search);
      // this.getData(val-1);
    },
    myModal: function () {
      // Reset Validation
      this.$v.$reset();

      // Remove is-valid from class list
      document.getElementById("levelInput").classList.remove("is-valid");
    },
  },

  mounted() {
    // data level di panggil ketika halaman web di load
    this.roleData();
    this.getData("0", this.pageSize, "default");
  },

  methods: {
    setNamaLevel(value) {
      this.formData.namaLevel = value;
      this.$v.formData.namaLevel.$touch();
      if (!this.$v.formData.namaLevel.$error) {
        document.getElementById("levelInput").classList.add("is-valid");
      }
    },
    setHarga(value) {
      this.formData.hargaLevel = value;
      this.$v.formData.namaLevel.$touch();
      if (!this.$v.formData.namaLevel.$error) {
        document.getElementById("hargaInput").classList.add("is-valid");
      }
    },

    pageChange() {
      // alert('test')
      this.getData(this.currentPage);
    },
    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },

    // fungsi untuk create data
    createData() {
      //buka modal
      this.myModal = true;

      // clear data sebelum post data jika ingin tambah data
      this.formData = {};

      //isi model actionsPost jadi insert
      this.actionPost = "insert";
      this.title = "Tambah";
    },

    //fungsi untuk update data
    updateData(value, index) {
      //buka modal
      this.myModal = true;

      // isi kembali data pada form untuk di update
      this.formData = value;

      //isi model actionsPost jadi update
      this.actionPost = "update";
      this.title = "Edit";
    },

    deleteData(item, index) {
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            // panggil fungsi delete level pada file level.service.js
            LevelService.deleteLevel(this.formData)
              //then kalau responsenya berhasil
              .then((response) => {
                // comment console console.log(response);
                this.alertDeleteSuccess();
                this.getData("0", this.pageSize, "default");
                // catch kalau response error
              })
              .catch((error) => {
                this.alertError();
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      LevelService.getLevel(currentPage, pageSize, filter)
        .then((response) => {
          loader.hide();
          // comment console console.log(response.data.data.content);
          this.items = response.data.data.content;
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
          setTimeout(() => loader.hide(), 1000);
        })
        .catch((error) => {
          loader.hide();
          // comment console console.log(error);
        });
    },

    // fungsi onclick ketika form isian di enter
    postData() {
      this.$v.$touch();
      if (this.actionPost == "insert") {
        if (this.$v.$invalid) {
          return;
        } else {
          this.insertData(this.formData);
        }
      } else if (this.actionPost == "update") {
        if (this.$v.$invalid) {
          return;
        } else {
          this.putData();
        }
      }
    },
    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      // comment console console.log(formData);
      // comment console console.log("posat");

      var vm = this;

      LevelService.postLevel(formData)
        .then((response) => {
          //tutup kembali modal
          this.myModal = false;

          // untuk manampilkan alert
          this.alertSuccess();

          // Remove is-valid from class list
          document.getElementById("levelInput").classList.add("is-valid");

          // untuk menampilkan data kembali
          vm.getData("0", this.pageSize, this.search);
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          // comment console console.log(error);
          // untuk manampilkan alert error
          this.alertError(error.response.data.message);
        });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    //fungsi untuk update data
    putData() {
      // comment console console.log("put");
      // comment console console.log(this.formData);

      var vm = this;
      LevelService.putLevel(this.formData)
        .then((response) => {
          //tutup kembali modal
          vm.myModal = false;

          // untuk manampilkan alert
          vm.alertEditSuccess();

          // Remove is-valid from class list
          document.getElementById("levelInput").classList.add("is-valid");

          // untuk menampilkan data kembali
          vm.getData("0", this.pageSize, this.search);
        })
        .catch((error) => {
          // comment console console.log(error);

          // untuk manampilkan alert errorr
          vm.alertError(error.response.data.message);
        });
    },        
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    }
  },
};
</script>